import { createContext, ReactNode, useReducer } from 'react';

interface INavigationContext {
  title: string;
  isHome: boolean;
  showSmartActions?: boolean;
  home?: string;
  disable?: boolean;
  currentPageRoute?: string;
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const initialState: INavigationContext = {
  title: '',
  isHome: false,
  home: undefined,
  maxWidth: undefined
};

export interface IAppContextAction {
  type: string;
  payload?: any;
}

const NavigationContextReducer = (state: INavigationContext, action: IAppContextAction): INavigationContext => {
  switch (action.type) {
    case 'INITIALISE_NAVIGATION':
      return {
        ...action.payload,
        isHome: action.payload.isHome === true,
        disable: action.payload.disable === true,
        showSmartActions: action.payload.showSmartActions === true,
        maxWidth: action.payload.maxWidth
      };

    default:
      return { ...state };
  }
};

const NavigationContext = createContext<{
  state: typeof initialState;
  dispatch: (action: IAppContextAction) => void;
}>({ state: initialState, dispatch: () => {} });

const NavigationContextProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [state, dispatch] = useReducer(NavigationContextReducer, { ...initialState });
  const value = { state, dispatch };
  return <NavigationContext.Provider value={value}>{props.children}</NavigationContext.Provider>;
};

const NavigationContextConsumer = NavigationContext.Consumer;

export { NavigationContext, NavigationContextProvider, NavigationContextConsumer };
